import styled from "@emotion/styled";

const IntroLeft = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.down("lg")} {
    height: 100%;
    justify-content: center;
    margin-inline: auto;
    text-align: center;
  }

  ${({ theme }) => theme.breakpoints.up("lg")} {
    justify-content: space-between;
    padding: 20px 40px 20px 30px;
    gap: 40px;
  }

  ${({ theme }) => theme.breakpoints.between("lg", "2lg")} {
    padding: 20px 40px 20px 10px;
  }
`;

export default IntroLeft;
